import {
  Heading,
  Box,
  Card,
  Flex,
  Text,
  Button,
  Spacer, Show, Hide
} from "@chakra-ui/react";
import "./nav.css";
import React from "react";
import resume from "./Mitali-Sinha-Resume.pdf";
import { Link } from "react-scroll";
import Toggle from "../Toggle/Toggle";
import { themeContext } from "../context/Context";
import { useContext } from "react";
import Drawer from "../drawer/drawer"


const Navbar = () => {
  const theme = useContext(themeContext);
  const darkmode = theme.state.darkMode;

  return (
    <div
      className="Nav"
      style={{
        backgroundColor: darkmode ? "rgb(54, 53, 53)" : "rgb(217, 235, 252)",
        color: darkmode ? "rgb(240, 231, 231)" : "black",
      }}
    >
      <Box h="8px" w="100%" background={"orangered"}></Box>
      {/* <Box h="100%" w="8px" background={"orangered"} mr="0px"></Box> */}
      <Card
        boxShadow={"dark-lg"}
        style={{
          backgroundColor: darkmode ? "rgb(54, 53, 53)" : "rgb(217, 235, 252)",
          color: darkmode ? "rgb(240, 231, 231)" : "black",
        }}
      >
        <Flex p={"2rem"}>
          <Box>
            <Heading as="h4" size="md">
            &#10094; Mitali Sinha &#x2215; &#10095;
            </Heading>
          </Box>
          <Spacer />
          {/* <Box ml={3}><Switch colorScheme='red' size='lg' color="red"/></Box> */}
          <Box ml={3}>
            <Toggle />
          </Box>
          <Spacer />
          <Hide below="sm">
            <Flex ml={3}>
              <Link
                spy={true}
                to="Navbar"
                smooth={true}
                activeClass="activeClass"
              >
                <Text
                  fontSize={["10px", "12px", "17px", "19px"]}
                  _hover={{
                    color: "orangered",
                    transform: "scale(1.3)",
                    cursor: "pointer",
                  }}
                >
                  Home
                </Text>
              </Link>
              <Link spy={true} to="aboutMe" smooth={true}>
                <Text
                  ml={[2, 3, 4, 5]}
                  fontSize={["10px", "12px", "17px", "19px"]}
                  _hover={{
                    color: "orangered",
                    transform: "scale(1.3)",
                    cursor: "pointer",
                  }}
                >
                  About Me
                </Text>
              </Link>
              <Link spy={true} to="skill" smooth={true}>
                <Text
                  ml={[2, 3, 4, 5]}
                  fontSize={["10px", "12px", "17px", "19px"]}
                  _hover={{
                    color: "orangered",
                    transform: "scale(1.3)",
                    cursor: "pointer",
                  }}
                >
                  Skills
                </Text>
              </Link>
              <Link spy={true} to="project" smooth={true}>
                <Text
                  ml={[2, 3, 4, 5]}
                  fontSize={["10px", "12px", "17px", "19px"]}
                  _hover={{
                    color: "orangered",
                    transform: "scale(1.3)",
                    cursor: "pointer",
                  }}
                >
                  Projects
                </Text>
              </Link>
              <Link spy={true} to="contact" smooth={true}>
                <Text
                  ml={[2, 3, 4, 5]}
                  fontSize={["10px", "12px", "17px", "19px"]}
                  _hover={{
                    color: "orangered",
                    transform: "scale(1.3)",
                    cursor: "pointer",
                  }}
                >
                  Contacts
                </Text>
              </Link>
            </Flex>
          </Hide>
          <Spacer />
          {/* <Link href={resume} download> */}
          <a href="https://drive.google.com/uc?export=download&id=1kFRomgT4-Zget0HpUOPbBv8M0F7zQYwt">
            <Button
              bg="orangered"
              color="white"
              fontSize={["10px", "12px", "17px", "19px"]}
              ml={[10, 3]}
              _hover={{
                background: "white",
                color: "orangered",
                border: "1px solid orangered",
              }}
              onClick={() =>
                window.open(
                  "https://drive.google.com/file/d/1kFRomgT4-Zget0HpUOPbBv8M0F7zQYwt/view?usp=sharing",
                  "_blank"
                )}
            >
              Resume
            </Button>
            </a>
          {/* </Link> */}
          <Show below="sm">
            <Box>
              <Drawer />
            </Box>
          </Show>
        </Flex>
      </Card>
    </div>
  );
};

export default Navbar;
